import { Typography } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { CONSTANTS, isDev } from "@theatticusapp/atticus-shared-components";
import { useAuthContext } from "../../../AuthContextWrapper";
import { SingleTextForm } from "../shared/SingleTextForm";

export const TurnAwayScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (email: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    try {
      console.log("entered email", email);
      // TODO: call api to email executor?  Could this be abused?
    } catch (error) {
      throw new Error("could not save data");
    }

    // flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title={`Sorry, Atticus currently does not support estate Beneficiaries or Heirs.`}
      subTitle="Would you like to invite the Executor?"
    >
      <SingleTextForm
        textLabel="Email address"
        inputMatches={{
          regexp: CONSTANTS.REGEX.email,
          failMessage: "Email address is not valid",
        }}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : isDev ? (
    <Typography>could not determine current screen</Typography>
  ) : (
    <></>
  );
};
